import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

export const createTicket = (ticket_data, media) => {
  try {
    return axios.post(
      BASE_URL + "tickets/createTicket",
      { ticket_data, media },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const addNewTicketData = (
  ticket_id,
  ticket_data,
  media,
  ticket_status,
) => {
  try {
    return axios.post(
      BASE_URL + "tickets/addNewTicketData",
      { ticket_id, ticket_data, media, ticket_status },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getAllUsersTickets = () => {
  try {
    return axios.post(
      BASE_URL + "tickets/getAllUsersTickets",
      {},
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const deleteTicket = (ticket_id) => {
  try {
    return axios.post(
      BASE_URL + "tickets/deleteTicket",
      { ticket_id },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const fileUpload = (file) => {
  try {
    return axios.post(BASE_URL + "chat/fileUpload", file, {
      "content-type": "multipart/form-data",
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getTickets = () => {
  try {
    return axios.post(
      BASE_URL + "tickets/getTickets",
      {},
      { "content-type": "multipart/form-data", headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getTicketThread = (ticket_id) => {
  try {
    return axios.post(
      BASE_URL + "tickets/getTicketThread",
      { ticket_id },
      { "content-type": "multipart/form-data", headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};
